import React, {useEffect, useState} from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import {useTranslation} from "react-i18next";
import {connect, setStore} from "trim-redux";
import {Typography} from "@mui/material";
import AddressIcon from "../AddressIcon";


function ViewDeliveryAddress({classes,address}){
    const { t } = useTranslation();


    return (
        <>
            {
                !!address &&
                <div className="flex-direction flex-column-md" style={{gap:5}}>
                   <div className="adrressLable">
                       <AddressIcon icon={address.icon} />
                       <Typography className="text"><strong>{address.label}</strong></Typography>
                   </div>
                    <Typography>{address.address}</Typography>
                </div>
            }
        </>

    );
}
const mapStateToProps = (state) => ({
    setting: state.setting,
});

export default withStyles(Styles)(connect(mapStateToProps)(ViewDeliveryAddress));
